/**
* Left Right Secondary JS
* -----------------------------------------------------------------------------
*
* All the JS for the Left Right Secondary component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'left-right-secondary',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.blue-backing' ).each( function() {
        gsap.from( this, {
          scrollTrigger: {
            trigger: this,
            start: 'top 50%',
            scrub: false,
          },
          left: 25,
          bottom: 0,
          duration: .5,
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'left-right-secondary', COMPONENT );
} )( app );
